import $ from 'jquery'

export default {
  start: () => {
    $(window).on('turbolinks:load', e => {
      $('.btn--dialog-confirm').each((i, el) => {
        el.addEventListener('click', e => {
          const message = $(el).data('message')
          const confirmValue = $(el).data('confirm-value')
          if (!message || !confirmValue) {
            return
          }

          const typedValue = window.prompt(message)
          if (String(typedValue) !== String(confirmValue)) {
            e.preventDefault()
            e.stopImmediatePropagation()
          }
        })
      })
    })
  }
}
